
// You can write more code here

/* START OF COMPILED CODE */

import Tile from "../../game/Tile";
import Tween = Phaser.Tweens.Tween;
import {LevelManager} from "~/js/game/LevelManager";
/* START-USER-IMPORTS */
import { Sounds } from '../../sounds';
/* END-USER-IMPORTS */

export default class Bumper extends Tile {

  constructor(scene: Phaser.Scene,levelManager:LevelManager, x?: number, y?: number, properties?:any[], texture?: string, frame?: number | string) {
    super(scene,levelManager, x ?? 0, y ?? 0,properties, texture || "game-tiles", frame ?? "bumper.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */

    // custom definition props

    if(properties != undefined) {
      for (let i = 0; i < properties?.length; ++i) {
        switch (properties[i].name) {
          case "BumperStartsAvailable":
            this.available = properties[i].value;
            break;
        }
      }
    }

    // this.available = availableOnStart;
    this.startingAvailableState = this.available;
    this.wasDownLastFrame = !this.available;
    this.updateAvailableVisuals();
    this.BumperSize = this.width;
  }

  /* START-USER-CODE */
  private scaleTween!:Tween;
  private available:boolean = true;
  private startingAvailableState:boolean = false;
  public BumperSize:number = 0;
  public wasDownLastFrame:boolean = false;
  private bumperCooldown:number = 0;

  hitTile(): boolean {
    
    if(this.LastCollisionTime > 0)
    {
      return false;
    }

    this.LastCollisionTime = 100;
    this.scaleX = 1.2;
    this.scaleY = 1.2;

    if(this.scaleTween !== undefined)
    {
      this.scaleTween.stop();
    }

    this.setTexture(this.texture.key,"bumper-lit.png");

    this.scaleTween = this.scene.tweens.add({
      targets: this,
      props: {
        scaleX: { value: 1, duration: 1000},
        scaleY: { value: 1, duration: 1000}
      },
      ease: 'Elastic.out'
    }).on("complete",()=>{
    });

    this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.PinballBumper, Sounds.Channel.SFX, { volume: 1 });
    this.scene.time.delayedCall(500, ()=>{this.updateAvailableVisuals()}, undefined, this);
    return true;
  }

  public toggleAvailable()
  {
    this.wasDownLastFrame = !this.available;
    
    
    this.available = !this.available;
    this.updateAvailableVisuals();
    this.bumperCooldown = 100;
  }

  public resetAvailable()
  {
    this.available = this.startingAvailableState;
    this.updateAvailableVisuals();
  }

  private updateAvailableVisuals()
  {
    if(this.available)
    {
      this.setTexture(this.texture.key,"bumper.png");
      this.setDepth(this.y);
    }
    else
    {
      this.setTexture(this.texture.key,this.levelManager.CurrentLevel.bumperDownKey);
      this.setDepth(0);
    }
  }

  public override updateTile(time: number, delta: number): void {
    super.update(time,delta);
    console.log("Bumper cooldown ", this.bumperCooldown);
    if(this.bumperCooldown > 0)
    {
      
      
      this.bumperCooldown -= delta;
      if(this.bumperCooldown < 0)
      {
        if(this.wasDownLastFrame)
        {
          this.wasDownLastFrame = false;
          console.log("Was down last frame: ", this.wasDownLastFrame);
        }
      }
    }
    this.LastCollisionTime -= delta;
    if(this.LastCollisionTime < 0)
    {
      this.LastCollisionTime = 0;
    }
  }

  public get Available()
  {
    return this.available;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
